/// <reference path="../modules/app.module.ts" />
/// <reference path="../objects/interfaces/ivalidationservice.ts" />

module App.Services {
    export class ValidationService implements App.Interfaces.IValidationService {
        static serviceId = 'validationService';

        static $inject = [
            '$state',
            '$rootScope',
            Services.NavigationService.serviceId
        ];

        _isLoadingStep: string = '';
        get isLoadingStep() {
            return this._isLoadingStep;
        }
        set isLoadingStep(val: string) {
            this._isLoadingStep = val;
            this.$rootScope.$broadcast(Constants.broadcast.validateTimerSet, val);
        }
        loadingStepTimer = null;

        constructor(private $state: ng.ui.IStateService,
            private $rootScope: Interfaces.IAppRootScope,
            private navigationService: App.Interfaces.INavigationService) {
            
            $rootScope.$on(Constants.broadcast.stepNameValidated, (event, next, current) => {
                this.navigationService.nextStep();
            });
        }

        goToNextStepValidated = () => {
            if (this.isLoadingStep == '') {
                this.currentStepIsValid();
            }
        }

        currentStepIsValid = () => {
            var currentStep = this.navigationService.currentStep();

            this.setLoadingTimer(currentStep.name);

            this.$rootScope.$broadcast(Constants.broadcast.validateStep, currentStep.name);
        }

        setLoadingTimer = (stepName) => {
            this.clearLoadingTimer();

            this.isLoadingStep = stepName;

            var self = this;
            self.loadingStepTimer = setTimeout(() => {
                self.isLoadingStep = '';
                self.loadingStepTimer = null;
            }, 5000);
        }

        clearLoadingTimer = () => {
            this.isLoadingStep = '';

            if (!this.loadingStepTimer)
                return;

            clearTimeout(this.loadingStepTimer);
            this.loadingStepTimer = null;
        }
    }
    app.service(ValidationService.serviceId, ValidationService);
}